import {
  DefaultButton,
  FontWeights,
  Modal,
  SelectionMode,
  getTheme,
  mergeStyleSets,
} from "@fluentui/react";
import {
  DetailsList,
  DetailsListLayoutMode,
} from "@fluentui/react/lib/DetailsList";
import { Icon } from "@fluentui/react/lib/Icon";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import moment from "moment";
import React, { useEffect } from "react";

const createdColumns = [
  {
    key: "name",
    name: "Name",
    fieldName: "name",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "time",
    name: "Created Date",
    fieldName: "dated",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "status",
    name: "Status",
    fieldName: "statusLabel",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "designation",
    name: "Designation",
    fieldName: "designation",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
];

const pendingColumns = [
  {
    key: "name",
    name: "Name",
    fieldName: "name",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "time",
    name: "Assigned Date",
    fieldName: "dated",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "designation",
    name: "Designation",
    fieldName: "designation",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },

  {
    key: "level",
    name: "level",
    fieldName: "level",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  }

];

const reviewsColumns = [
  {
    key: "name",
    name: "Name",
    fieldName: "name",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "time",
    name: "Reviewed Date",
    fieldName: "dated",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "noting",
    name: "Noting",
    fieldName: "noting",
    minWidth: 100,
    maxWidth: 300,
    isResizable: true,
  },
  {
    key: "designation",
    name: "Designation",
    fieldName: "designation",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
];
 

 export const PendingFiles = React.createContext('');

function FileTimeline({ isOpen, onDismiss, fetchData, timeLineDetails  }) {
  
  useEffect(() => {
     
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  function _renderItemColumn(item, index, column) {

     const fieldContent = item[column.fieldName];

    switch (column.key) {
      case "time":
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {moment(fieldContent).format("DD-MM-YYYY hh:mm a")}
          </span>
        );
      case "noting":
        return (
          <TooltipHost
            content={fieldContent}
            calloutProps={{ gapSpace: 0 }}
            styles={{ root: { display: "inline-block" } }} >
               
            <span style={{ fontSize: "14px", textAlign: "center" }}>
              {fieldContent || "-"}
            </span>
          </TooltipHost>
        );
         
      default:
        return (
          <span style={{ fontSize: "14px" , textAlign: "center" }}>
             {timeLineDetails.level==fieldContent?<span style={{color:"green" }}  className="font-weight-bold">{fieldContent} </span>:<span > {fieldContent} </span> }
          </span>
        );
    }
  }



  return (
      
    <Modal
     
      isOpen={isOpen}
      onDismiss={onDismiss}
      isBlocking={false}
      containerClassName={contentStyles.container}
     >
         
      <div className={contentStyles.header}>
        <p className="page-title">File Timeline</p>
        <DefaultButton
          styles={iconButtonStyles}
          ariaLabel="Close popup modal"
          onClick={onDismiss}
        >
          <Icon iconName="ChromeClose" />
        </DefaultButton>
      </div>
      <div className={contentStyles.body}>
        <p className="font-semibold text-base m-0">Created:</p>
        <DetailsList
          items={timeLineDetails ? timeLineDetails.created : []}
          columns={createdColumns}
          getKey={(item) => `${item.id}`}
          selectionMode={SelectionMode.none}
          setKey="none"
          layoutMode={DetailsListLayoutMode.justified}
          onRenderItemColumn={_renderItemColumn}
          isHeaderVisible={true}
        />
      </div>
      {timeLineDetails && timeLineDetails.pending ? (
        <div className={contentStyles.body}>
          <p className="font-semibold text-base m-0"> Pending: </p>

          <DetailsList
            items={timeLineDetails ? timeLineDetails.pending : []}
            columns={pendingColumns}
            getKey={(item) => `${item.id}`}
            selectionMode={SelectionMode.none}
            setKey="none"
            layoutMode={DetailsListLayoutMode.justified}
            onRenderItemColumn={_renderItemColumn}
            isHeaderVisible={true}
          />

           
           
  {/* {
      timeLineDetails.length!=0?
      <PendingFiles.Provider value={timeLineDetails}   >
      <HODReport />
      </PendingFiles.Provider>:""
       } */}
   




        </div>
      ) : null }

     




      {timeLineDetails && timeLineDetails.reviews ? (
        <div className={contentStyles.body}>
          <p className="font-semibold text-base m-0">Reviewed:</p>
          <DetailsList
            items={timeLineDetails ? timeLineDetails.reviews : []}
            columns={reviewsColumns}
            getKey={(item) => `${item.id}`}
            selectionMode={SelectionMode.none}
            setKey="none"
            layoutMode={DetailsListLayoutMode.justified}
            onRenderItemColumn={_renderItemColumn}
            isHeaderVisible={true}
        />

        </div>
      ) : null}
    </Modal>
  );
}

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
    width: "80%",
    height: "80%",
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 24px",
    },
  ],
  body: {
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    overflowY: "hidden",
    selectors: {
      p: { margin: "14px 0" },
      "p:first-child": { marginTop: 0 },
      "p:last-child": { marginBottom: 0 },
    },
  },
});

const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
    border: "none",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};


export default FileTimeline;

